<script setup lang="ts">
import { provide } from 'vue';
import { loadingStateInjectionKey } from './internal';

// Each dialog is its own error context (I-3515, #3535): the kit inputs in an overlay's panel never
// take the save status of the field the overlay is anchored to. A component of its own so an
// overlay can wrap its panel content only — the trigger next to it keeps the field's status.
provide(loadingStateInjectionKey, null);
</script>

<template>
  <slot />
</template>
